import Vue from 'vue'
import $ from 'jquery'
import axios from 'axios'
const BaseApi = {
    loadRights: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/rights/list?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    createRight: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/rights?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadById: function (itemId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/rights/' + itemId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    deleteItem: function (companyId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/rights/' + companyId + '/delete?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    updateRight: function (item, fnSuccess, fnError) {
        Vue.prototype.$api.showIdle()
        var url = Vue.prototype.$config.HOST + '/v1/rights/' + item.guid + '?time=' + new Date().getTime()
        axios({
            method: 'post',
            data: item,
            url: url,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnSuccess) {
                    fnSuccess(response.data)
                }
            }, function (error) {
                Vue.prototype.$api.hideIdle()
                Vue.prototype.$eventHub.$emit('OnShowError', error)
                if (fnError) {
                    fnError(error, status, error)
                } else {
                    console.error('error')
                    console.error(error)
                    console.log(status)
                }
            })
    },
    hasRight: function (rightName, config) {
        if (!Vue.prototype.$api.getCredentials().data) return false
        var rights = Vue.prototype.$api.getCredentials().data.rights
        var allowed = rights[rightName]
        if (!allowed) {
            if (config) {
                if (config.orClausel) {
                    allowed = allowed || config.orClausel
                }
            }
        }
        return allowed
    }
}


export default BaseApi
